<!-- src/app/features/not-found/not-found.html -->
<div class="main-error-container">

  <!-- Main title -->
  <ui-atom-text
    class="title-error"
    [text]="'errors.notFound.title' | translate"
    type="main-title">
  </ui-atom-text>
  <!-- End Main title -->

  <!-- Message -->
  <ui-atom-text
    class="message-error"
    [text]="'errors.notFound.message' | translate"
    type="title">
  </ui-atom-text>
  <!-- END Message -->

  <!-- Go Back Button -->
  <ui-atom-button
    (buttonClick)="handleGoBackClick()"
    [disabled]="false"
    [tooltip]="'errors.notFound.tooltip' | translate"
    rules="main"
    styling="filled"
    [text]="'buttons.goBack' | translate">
  </ui-atom-button>
  <!-- END Go Back Button -->

</div>
